import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { finalize, first } from "rxjs/operators";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Employee } from "../../core/model/employee/employee";
import { Bank } from "../../core/model/bank";
import { Direction } from "../../core/model/direction";
import { Departement } from "../../core/model/departement";
import { Annee } from "../../core/model/annee";
import { Conges } from "../../core/model/conges";
import { BankService } from "../../core/service/bank.service";
import { DirectionService } from "../../core/service/direction.service";
import { DepartementService } from "../../core/service/departement.service";
import { EmployeeService } from "../../core/service/employee.service";
import { AnneeService } from "../../core/service/annee.service";
import { CongesService } from "../../core/service/conges.service";
import { AddCongesComponent } from "../add-conges/add-conges.component";
import { EditCongesComponent } from "../edit-conges/edit-conges.component";
import { UpdateEmployee } from "../../core/model/employee/update-employee";

@Component({
  selector: "app-edit-user",
  templateUrl: "./edit-user.component.html",
  styleUrls: ["./edit-user.component.scss"],

  //
  animations: [
    trigger("detailExpand", [
      state("collapsed", style({ height: "0px", minHeight: "0" })),
      state("expanded", style({ height: "*" })),
      transition(
        "expanded <=> collapsed",
        animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")
      ),
    ]),
  ],
  //
})
export class EditUserComponent implements OnInit {
  pressButton: Boolean = false;
  form: FormGroup;
  erreur: string = null;

  public file: File;
  public photo: string | ArrayBuffer;
  public photoContentType: String;

  userId: number;
  employee: Employee;
  banks: Bank[];
  directions: Direction[];
  departements: Departement[];

  annees: Annee[];

  conges: Conges[];
  congesArray: Array<Conges[]> = [];

  displayedAnneesColumnsList: string[] = ["annee", "actions"];

  updateEmployee: UpdateEmployee = new UpdateEmployee();

  constructor(
    private _router: Router,
    private modalService: NgbModal,
    private fb: FormBuilder,
    private _bankService: BankService,
    private _drectionService: DirectionService,
    private _departementService: DepartementService,
    private _employeeService: EmployeeService,
    private _activatedRoute: ActivatedRoute,
    private _anneeService: AnneeService,
    private _congesService: CongesService
  ) {
    this.createForm();
  }

  createForm() {
    this.form = this.fb.group({
      active: [null, Validators.compose([Validators.required])],
      matricule: [null, Validators.compose([Validators.required])],
      poste: [null, Validators.compose([Validators.required])],
      firstname: [null, Validators.compose([Validators.required])],
      lastname: [null, Validators.compose([Validators.required])],
      businessEmail: [null, Validators.compose([Validators.required])],
      businessPhone: [null, Validators.compose([Validators.required])],
      username: [null, Validators.compose([Validators.required])],
      direction: [null, Validators.compose([Validators.required])],
      departement: ["", Validators.compose([Validators.required])],
      bank: [null, Validators.compose([Validators.required])],
      codeAgent: [null, Validators.compose([Validators.required])],
      initiale: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this._activatedRoute.params.subscribe((params: Params) => {
      this.userId = params["userId"];
      this.getEmployeeById(this.userId);
      this.getDirections();
      this.getBanks();
      this.getAllAnnee();
    });
  }

  getEmployeeById(userId) {
    this._employeeService.getEmployeeById(userId).subscribe(
      (data) => {
        this.employee = data;

        this.getDepartementsByDirection(this.employee.departement.direction.id);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getDepartementsByDirection(directionid) {
    this._departementService.getDepartementsByDirection(directionid).subscribe(
      (data) => {
        this.departements = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getDirections() {
    this._drectionService.getAllDirections().subscribe(
      (data) => {
        this.directions = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  changeDepartements() {
    let directionid = this.form.controls["direction"].value;
    this.getDepartementsByDirection(directionid);
  }

  getBanks() {
    this._bankService.getAllBanks().subscribe(
      (data) => {
        this.banks = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  changeListener($event) {
    this.readThis($event.target);
  }

  readThis(inputValue: any): void {
    this.file = inputValue.files[0];
    var myReader: FileReader = new FileReader();

    myReader.onloadend = (e) => {
      this.employee.photo = myReader.result.toString().split(",")[1];
      this.employee.photoContentType = this.file.type;
    };
    myReader.readAsDataURL(this.file);
  }

  getAllAnnee() {
    this._anneeService.getAll().subscribe(
      (data) => {
        this.annees = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getCongesByAnnee(annee) {
    this._congesService
      .getListCongesByAnneeAndUsername(this.employee.username, annee)
      .subscribe(
        (data) => {
          this.conges = data;
          this.congesArray[annee] = this.conges;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  add(annee): void {
    const modalRef = this.modalService.open(AddCongesComponent, {
      centered: true,
    });
    modalRef.componentInstance.annee = annee;
    modalRef.componentInstance.username = this.employee.username;

    modalRef.result.then(
      (data) => {
        // on close
        this.getCongesByAnnee(annee);
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  edit(annee, congeId): void {
    const modalRef = this.modalService.open(EditCongesComponent, {
      centered: true,
    });
    modalRef.componentInstance.congeId = congeId;

    modalRef.result.then(
      (data) => {
        // on close
        this.getCongesByAnnee(annee);
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  delete(annee, congeId) {
    this._congesService
      .deleteConge(congeId)
      .pipe(first())
      .subscribe(
        (data) => {
          this.getCongesByAnnee(annee);
        },
        (error) => {
          console.log(error);
        }
      );
  }

  save(): void {
    this.updateEmployee.employeeId = this.employee.id;
    this.updateEmployee.matricule = this.form.value.matricule;
    this.updateEmployee.poste = this.form.value.poste;
    this.updateEmployee.firstname = this.form.value.firstname;
    this.updateEmployee.lastname = this.form.value.lastname;
    this.updateEmployee.mobilePhone = this.form.value.mobilePhone;
    this.updateEmployee.businessEmail = this.form.value.businessEmail;
    this.updateEmployee.businessPhone = this.form.value.businessPhone;
    this.updateEmployee.photo = this.employee.photo;
    this.updateEmployee.photoContentType = this.employee.photoContentType;
    this.updateEmployee.initiale = this.form.value.initiale;
    this.updateEmployee.codeAgent = this.form.value.codeAgent;
    this.updateEmployee.departementId = this.form.value.departement;

    this.pressButton = true;
    this._employeeService
      .update(this.updateEmployee)
      .pipe(
        first(),
        finalize(() => {
          this.pressButton = false;
        })
      )
      .subscribe(
        (data) => {
          this.goToList();
        },
        (error) => {
          console.log(error);
          this.erreur = error.error.message;
        }
      );
  }

  cancel(): void {
    this.goToList();
  }

  private goToList(): void {
    this._router.navigateByUrl("/parametrage/user");
  }

  assignerPortefeuilleAuBackUpByUsername() {
    this._congesService
      .assignerPortefeuilleAuBackUpByUsername(this.employee.username)
      .subscribe(
        (data) => {},
        (error) => {
          console.log(error);
        }
      );
  }
}
